import { render, staticRenderFns } from "./EpDangerLevelReport.vue?vue&type=template&id=2e3765d4&scoped=true&"
import script from "./EpDangerLevelReport.vue?vue&type=script&lang=js&"
export * from "./EpDangerLevelReport.vue?vue&type=script&lang=js&"
import style0 from "./EpDangerLevelReport.vue?vue&type=style&index=0&id=2e3765d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3765d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e3765d4')) {
      api.createRecord('2e3765d4', component.options)
    } else {
      api.reload('2e3765d4', component.options)
    }
    module.hot.accept("./EpDangerLevelReport.vue?vue&type=template&id=2e3765d4&scoped=true&", function () {
      api.rerender('2e3765d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/epreport/EpDangerLevelReport.vue"
export default component.exports